import { Schema } from '../../types'
import { commonColumns } from '../common_schema'

export const sqlSchema: Schema = {
  title: 'SQL',
  level: 1,
  columns: commonColumns
}
